// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { SidebarService } from '../../services/sidebar.service';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { NetworkStatusService } from '../../services/network.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  standalone: false
})
export class LayoutComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  showSideBar$!: Observable<boolean>;
  isOnline = true;
  showOfflineModal = false;

  constructor(
    private router: Router,
    private sideBarService: SidebarService,
    private netStatus: NetworkStatusService) {
  }

  ngOnInit() {
    this.showSideBar$ = this.sideBarService.show$.pipe(delay(0));

    this.netStatus.onlineStatus$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(status => {
      this.isOnline = status;
      if (!status) this.showOfflineModal = true;
      if (status) this.showOfflineModal = false;
    });
  }

  dismissModal() {
    this.showOfflineModal = false;
  }

}
